export default {"src":"/_next/static/media/landing-2-shape.63a8de42.svg","height":207,"width":1920,"blurWidth":0,"blurHeight":0};